//Whenever we open a toggle section, we want to anchor the user to the top of that section

$('.js-toggle-section').on('shown.bs.collapse', function () {
    const sectionLocation = $(this).offset().top - 75;
    $(window).scrollTop(sectionLocation);
  });